import { render, staticRenderFns } from "./NavEvents.vue?vue&type=template&id=2172108f"
import script from "./NavEvents.vue?vue&type=script&lang=js"
export * from "./NavEvents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports